import Cookies from 'cookies-js';
import axios from 'axios';
import { Loading, Message } from 'element-ui';
import router from '../router/router';
import store from '../store';
import { createAccount, loginUser, logoutUser } from '../services/user';
import arrayObjectIndexOf from '../js/arrayObjectIndexOf';
import * as groups from '../js/user-groups';

export default {
  login(context, creds) {
    loginUser(creds).then(response => response.data).then((data) => {
      store.dispatch('loginUser', data);
      const csrftoken = Cookies.get('csrftoken');
      axios.defaults.headers.common['X-CSRFToken'] = csrftoken;
      if (arrayObjectIndexOf(store.getters.getUser.groups, groups.FINANCIAL, 'name') !== -1) {
        router.push('/payments');
      } else {
        router.push('/');
      }
    }).catch((error) => {
      context.loginLoading = false; // eslint-disable-line no-param-reassign
      if (error.response.data.message) {
        Message.error(error.response.data.message);
      } else {
        Message.error('Something went wrong! Try again.');
      }
    });
  },
  register(context, creds) {
    const loading = Loading.service({ fullscreen: true });
    createAccount(creds).then(response => response.data).then(() => {
      // store.dispatch('loginUser', data)
      loading.close();
      const csrftoken = Cookies.get('csrftoken');
      axios.defaults.headers.common['X-CSRFToken'] = csrftoken;
      router.push('/login');
      Message.success({
        showClose: true,
        message: 'Success! Your account is now pending approval.',
        type: 'success',
        duration: 10000,
      });
    }).catch((error) => {
      if (error.response.data.message) {
        Message.error(error.response.data.message);
      } else {
        Message.error('Something went wrong! Try again.');
      }
    });
  },
  logout() {
    logoutUser().then(response => response.data).then(() => {
      store.dispatch('logoutUser');
      router.go({ name: 'login' });
      Message.success('Logout Success!');
    }).catch(() => {
      Cookies.expire('authenticatedAccount');
      Cookies.expire('sessionid');
      router.go({ name: 'login' });
      Message.success('Logout Success!');
    });
  },
  checkAuth(next) {
    const isAuth = Cookies.get('authenticatedAccount');
    if (isAuth) {
      store.dispatch('setUserIsLogged');
      const csrftoken = Cookies.get('csrftoken');
      axios.defaults.headers.common['X-CSRFToken'] = csrftoken;
      next();
    } else {
      store.dispatch('logoutUser');
      const csrftoken = Cookies.get('csrftoken');
      axios.defaults.headers.common['X-CSRFToken'] = csrftoken;
      next('/login');
    }
  },
  getAuthHeader() {
    return {
      'X-CSRFToken': Cookies.get('csrftoken'),
    };
  },
};



// WEBPACK FOOTER //
// ./src/auth/index.js